import { render, staticRenderFns } from "./RefillDetail.vue?vue&type=template&id=1591e60b&scoped=true"
import script from "./RefillDetail.vue?vue&type=script&lang=js"
export * from "./RefillDetail.vue?vue&type=script&lang=js"
import style0 from "./RefillDetail.vue?vue&type=style&index=0&id=1591e60b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1591e60b",
  null
  
)

export default component.exports